import { embed, play } from '@site-module/embed';

export default function initVideoCards() {
    // video in show list cards and production detail heroes
    document.querySelectorAll('.thumb[data-video-url], #showHeaderImage [data-video-url], .headerImgContainer [data-video-url]').forEach((parent) => {
        let button = parent.querySelector('button');

        button.onclick = async(event) => {
            event.preventDefault();
            event.stopPropagation();

            parent.classList.add('video-loaded');

            const video_url = parent.dataset.videoUrl;
            await embed(parent, video_url, 'autoplay');
            play(video_url); // autoplay should work, this is to give it another kick in the butt if needed
            const embedded = window.embeds[video_url];
            const iframe = embedded.element.querySelector('iframe');
            iframe?.focus();
            button.remove();
        };
    });
}
